import api from '../../../api';

export const searchQuantalysFunds = async (query) => {
    try {
        const response = await api.get('/quantalys/search', {
            params: { q: query }
        });
        return response.data;
    } catch (error) {
        console.error("Erreur recherche Quantalys", error);
        throw error;
    }
};

export const getFundDetails = async (isin) => {
    try {
        const response = await api.get(`/quantalys/fund/${isin}`);
        return response.data;
    } catch (error) {
        console.error("Erreur détails fonds Quantalys", error);
        throw error;
    }
};

export const importProductToCatalogue = async (fundData) => {
    try {
        const response = await api.post('/quantalys/import', fundData);
        return response.data;
    } catch (error) {
        console.error("Erreur import produit", error);
        throw error;
    }
};

